// extracted by mini-css-extract-plugin
export default {"container":"YFveWU","link":"vYilfO","term":"JEGk06"};